/**
 * @desc 获取登录权限信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.QueryUserLoginPermissionResponse>>> {
  return defHttp.get({
    url: '/web/userPermission/loginPermission',
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.QueryUserLoginPermissionResponse>>> {
  return defHttp.get({
    url: '/mock/web/userPermission/loginPermission',
  });
}
